import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';
import Button from '@amzn/meridian/button';
import Box from '@amzn/meridian/box';
import { useNavigate } from 'react-router-dom';

export const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#F4F6F9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <Box type="outline" spacingInset="800" width={480}>
        <Column spacing="medium" alignmentHorizontal="start">
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 24,
              backgroundColor: '#FBE9E7',
              color: '#B30017',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
              fontWeight: 700,
            }}
            aria-hidden="true"
          >
            !
          </div>
          <Heading level={2} type="h200">
            Admin access required
          </Heading>
          <Text>
            You don&apos;t have permission to manage RBAC configuration. Admin access is granted to
            members of the <code>ft-cogit-admin</code> POSIX group with the{' '}
            <code>admin</code> operation enabled.
          </Text>
          <Text type="b200" color="secondary">
            Contact the GFT team if you believe this is incorrect.
          </Text>
          <Row spacing="small">
            <Button type="primary" onClick={() => navigate('/')}>
              Back to chat
            </Button>
          </Row>
        </Column>
      </Box>
    </div>
  );
};
